import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getCreateTaskError() {
      return getState().error;
    },
    isTaskCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isTaskCreationRequestPending() {
      return getState().request.isPending;
    },
    isTaskCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
